import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { NotificationService } from '../../services/notifications.service';
import { Application } from '../../models/application'
import { AuthService } from '../../services/auth.service'
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-notification-home',
  templateUrl: './notification-home.component.html',
  styleUrls: ['./notification-home.component.scss'],
  standalone: false,
})
export class NotificationHomeComponent implements OnInit {

  /*
  This property is to hold applications to be shown in the grid
  */
  gridItems: Application[] = [];

  appDisplay:number= Number.parseInt(environment.appNameDisplayLength);

  /*
  This property is to typecast response as application type
  */
  appData: Application = new Application();

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    public authService: AuthService,
    public userService: UserService,
    private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    sessionStorage.removeItem("appName");
    this.userService.getCurrentUser();
    this.gridItems = this.notificationService.applicationDetails;
    this.notificationService.applications$.subscribe((apps) => {
      this.gridItems = apps;
      this.cdr.detectChanges();
    });
  }

  /**
  * This method is to fetch the application from the api
  * @returns gridItems
  */
  fetchUserApplication(userId: string) {
    this.notificationService.getApplications(userId).subscribe((resultData: any) => {
      this.notificationService.setApplications(resultData);
      this.cdr.detectChanges();
    })
  }

  /**
   * This method navigates user to preferences screen of specific application
   * @param appData
   */
  navigateToPreference(appData: any) {
    localStorage.setItem('appName', appData.applicationName);
    let url = '/notification/' + appData.id + '/preference';
    this.router.navigate([url]);
  }

  applicationNameDisplay(appName: string){
    if(appName.length > this.appDisplay){
      return appName.substring(0,this.appDisplay-10).concat("...");
    }
    else{
      return appName;
    }
  }
}